module.exports = __webpack_public_path__ + "img/grey_056.1e16f8a2.png";